<template>
<div class="chapter">
<div class="inner_page">
<p class="c5" id="calibre_pb_4"> <br class="calibre2"/></p>
<p class="c7">Monsters are real…they live inside us. And sometimes
they win. –Stephen King</p>
<p class="c6"> <br class="calibre2"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_005.vue?06759a63